// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3GhM_","legacyBtn":"MutateMid_legacyBtn__3wT1b"};